export default __webpack_public_path__ + "static/media/inventoryManagement.d394cd9b.png";